/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */

/**
 * Contact type
 */
export type DepartmentLocationApiResourceType = typeof DepartmentLocationApiResourceType[keyof typeof DepartmentLocationApiResourceType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DepartmentLocationApiResourceType = {
  email: 'email',
  phone: 'phone',
} as const;
